export const isTouchDevice = () => {
  const out = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  return out;
};
